import { FC } from 'react';
import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import { PR_DISCLAIMER } from 'constants/languageConstants';
import styles from './planRecommenderDisclaimer.module.less';

const PlanRecommenderDisclaimer: FC = () => {
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.disclaimerWrapper}>
      <p className={styles.disclaimerText}>
        {getText(PR_DISCLAIMER, language)}
      </p>
    </div>
  );
};

export default PlanRecommenderDisclaimer;
